import { graphql, readInlineData } from 'react-relay/legacy.js';
import * as tracking from 'dibs-tracking';

import { type trackingHelpers_rewards$key } from './__generated__/trackingHelpers_rewards.graphql.ts';
import { type trackingHelpers_user$key } from './__generated__/trackingHelpers_user.graphql.ts';

type FirmStatusArgs = {
    rewards: trackingHelpers_rewards$key | null | undefined;
    user: trackingHelpers_user$key | null | undefined;
};

export const getFirmStatusTrackingParam = ({ rewards, user }: FirmStatusArgs): string => {
    const rewardsData = readInlineData(
        graphql`
            fragment trackingHelpers_rewards on TradeFirmRewards @inline {
                currentProgram {
                    programInfo {
                        code
                    }
                }
            }
        `,
        rewards
    );

    const userData = readInlineData(
        graphql`
            fragment trackingHelpers_user on User @inline {
                serviceId
                isVerifiedTrade
            }
        `,
        user
    );

    let firmStatus = 'logged out';
    const firmStatusCode = rewardsData?.currentProgram?.programInfo?.code;

    if (userData?.serviceId) {
        if (firmStatusCode) {
            firmStatus = firmStatusCode.toLowerCase();
        } else if (userData?.isVerifiedTrade) {
            firmStatus = 'firmless';
        } else {
            firmStatus = 'consumer';
        }
    }

    return firmStatus;
};

type PageSubType = 'current benefits' | 'program overview';

type PageViewParams = {
    pageSubType: PageSubType;
    firmStatus: string;
};
export const trackPageview: (params: PageViewParams) => void = ({ pageSubType, firmStatus }) => {
    tracking.trackPageview({
        url: window.location.href,
        additional: {
            pageType: 'rewards',
            pageSubType,
            firmStatus,
        },
    });
};

type EventParms = {
    label: string;
    firmStatus: string;
};

export const trackEvent = ({ label, firmStatus }: EventParms): void => {
    tracking.trackEvent({
        category: 'trade features',
        action: 'trade rewards',
        label,
        additional: {
            firmStatus,
        },
    });
};
